<template>
  <div class="flex items-center flex-col justify-center min-h-screen sans-serif">
    <div class="w-full max-w-xs">
      <form class="bg-white shadow-md rounded-lg pt-4 pb-8 mb-4 relative" id="login"
            v-on:submit.prevent="passwordReset">
        <div class="absolute badge-position">
          <span class="text-white rounded-full bg-blue-light px-4 py-2">
            Aggregator
          </span>
        </div>
        <div class="px-8 pt-4">
          <div class="text-center">
            <Logo></Logo>
          </div>
          <h1 class="py-4 text-2xl text-navy text-center font-semibold">Reset password!</h1>
          <p class="text-navy-light opacity-75 text-center">Enter your email address below and we'll send you
            instructions on how to reset your password.</p>
        </div>
        <div class="mt-4 bg-green px-8 py-3" v-if="emailSuccess">
          <p class="text-sm text-white text-bold">Password Reset Request has been sent to your email</p>
        </div>
        <div class="mb-4 px-8 pt-8">
          <label class="label">
            Email Address
          </label>
          <input class="appearance-none border rounded w-full py-4 px-3 text-navy" v-model="email" id="email"
                 name="email" type="email" placeholder="Email address" v-validate="'required|email'"
                 :class="{'border-red': errors.has('email') }">
          <p class="text-red text-xs italic mt-2" v-show="errors.has('email')">Please enter an email address</p>
        </div>
        <div class="flex px-8 mt-3">
          <input type="submit" value="Send"
                 class="bg-green hover:opacity-75 text-white font-bold py-3 px-4 rounded w-full text-lg">
        </div>
      </form>
    </div>
    <div class="border-t border-grey-lightest mt-8">
      <BrokerFooter></BrokerFooter>
    </div>
  </div>
</template>

<script>
import Logo from '@/assets/Logo';
import BrokerFooter from '@/components/BrokerFooter';

export default {
  name: 'BrokerForgotPassword',
  metaInfo: {
    title: 'Reset Password | SocietyOne Personal Loans',
  },
  $_veeValidate: {
    validator: 'new',
  },
  components: {Logo, BrokerFooter},
  data() {
    return {
      email: '',
      emailSuccess: false,
    };
  },
  methods: {
    async passwordReset() {
      const validate = await this.$validator.validateAll();
      // const vm = this;
      if (validate) {
        try {
          const data = await this.$http.post('aggregator/forgot-password', {
            email: this.email,
          });

          if (data) {
            this.emailSuccess = true;
          }
        } catch (e) {
          this.$toasted.error(`Error: ${(e.body && e.body.error) || e.message || 'Could not reset password'}`)
        }
      }
    },
  },
};
</script>

<style scoped>
.badge-position {
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/pages/Aggregator/AggregatorForgotPassword.vue